import { Grid, InputAdornment, TextField, Typography } from '@mui/material';
import { currencySymbol } from '../../../../utils/currency';
import { currencyHeading } from './CashCurrencyStepper';

const SALES_FIELDS = [
  { field: 'mercadoPago', label: 'MercadoPago' },
  { field: 'pos', label: 'POS' },
  { field: 'pedidosYa', label: 'PedidosYa' },
];

/**
 * Un paso de la apertura/cierre de caja: lo de UNA moneda distinta de pesos. Efectivo contado y, al cerrar, lo cobrado por los otros
 * medios, con la moneda a la vista en el título y en cada monto.
 */
export default function ForeignCurrencyCashForm({ currency, values, onChange, showSales = false, lockPos = false }) {
  const setField = (field, value) => onChange({ ...values, [currency.code]: { ...(values[currency.code] || {}), [field]: value } });
  const own = values[currency.code] || {};
  const adornment = { startAdornment: <InputAdornment position="start">{currencySymbol(currency.code)}</InputAdornment> };

  return (
    <>
      <Typography variant="h6" sx={{ mb: 0.5 }}>{currencyHeading(currency.code)}</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        {showSales
          ? `Declará lo que hay en caja y lo cobrado en ${currency.label.toLowerCase()}. Si no se vendió en esta moneda, dejá 0.`
          : `Contá el efectivo que hay en caja en ${currency.label.toLowerCase()}. Si no vas a vender en esta moneda, dejá 0.`}
      </Typography>

      <Typography variant="subtitle2" sx={{ mb: 1 }}>Efectivo en caja</Typography>
      <TextField
        size="small"
        fullWidth
        type="number"
        label="Efectivo contado"
        value={own.declaredCash ?? ''}
        onChange={(e) => setField('declaredCash', e.target.value)}
        InputProps={adornment}
        inputProps={{ min: 0, step: '0.01' }}
      />

      {showSales && (
        <>
          <Typography variant="subtitle2" sx={{ mt: 3, mb: 1 }}>Cobrado por otros medios</Typography>
          <Grid container spacing={1.5}>
            {SALES_FIELDS.map(({ field, label }) => (
              <Grid item xs={12} sm={4} key={field}>
                <TextField
                  size="small"
                  fullWidth
                  type="number"
                  label={label}
                  value={own[field] ?? ''}
                  onChange={(e) => setField(field, e.target.value)}
                  disabled={field === 'pos' && lockPos}
                  helperText={field === 'pos' && lockPos ? 'Lo informa el POS al cerrar el lote' : undefined}
                  InputProps={adornment}
                  inputProps={{ min: 0, step: '0.01' }}
                />
              </Grid>
            ))}
          </Grid>
        </>
      )}
    </>
  );
}

/** Arma `currency_balances` para el backend a partir de lo cargado en los pasos de cada moneda. */
export const buildCurrencyBalances = (currencies, values) =>
  currencies.map(({ code }) => {
    const v = values[code] || {};
    const num = (x) => {
      const n = parseFloat(x);
      return Number.isFinite(n) && n >= 0 ? n : 0;
    };
    return {
      currency: code,
      declared_cash: num(v.declaredCash),
      pos: num(v.pos),
      pedidos_ya: num(v.pedidosYa),
      mercado_pago: num(v.mercadoPago),
    };
  });
